import React from "react";
import PageHero from "@/components/PageHero";
import FormationsOverview from "@/components/FormationsOverview";
import NiveauxAdmission from "@/components/NiveauxAdmission";
import RythmesFormation from "@/components/RythmesFormation";
import Programs from "@/components/Programs";
import CampusWorld from "@/components/CampusWorld";
import Quiz from "@/components/Quiz";
import AdmissionsFaq from "@/components/AdmissionsFaq";
import { HERO_IMAGES } from "@/data/heroImages";

export default function FormationsPage() {
  return (
    <>
      <FormationsOverview />
      <PageHero
        eyebrow="Nos formations"
        title="Sept programmes, une même"
        italicWord="ambition"
        subtitle="Du Bachelor à l'Executive MBA, un parcours conçu comme un sprint d'innovation. Chaque programme délivre le diplôme officiel d'ECL, avec 70% de pratique et un réseau international."
        crumb="Formations"
        image={HERO_IMAGES.formations}
      />
      <NiveauxAdmission />
      <RythmesFormation />
      <Quiz />
      <Programs />
      <AdmissionsFaq />
      <CampusWorld />
    </>
  );
}
